<template>
  <div style="padding-top: 60px">
    <div class="policyList overflow bgfff">
      <div class="fl mr18 mt2">
        <van-dropdown-menu active-color="#6D90E2">
          <van-dropdown-item
            @change="changeClass"
            v-model="value"
            :options="option"
          />
        </van-dropdown-menu>
      </div>
      <div
        v-for="(item, index) in sortList"
        :key="index"
        class="fl mr15 mt2"
        @click="querySelect(index)"
      >
        <div
          :class="[item.id == isId ? 'active fl type_title' : 'fl type_title']"
        >
          {{ item.name }}
        </div>
        <div class="fl">
          <img
            v-if="item.sort == 1"
            class="sotr_pic"
            src="../images/policy/sort-up.svg"
            alt=""
          />
          <img
            v-else-if="item.sort == 2"
            class="sotr_pic"
            src="../images/policy/sort-down.svg"
            alt=""
          />
          <img v-else class="sotr_pic" src="../images/policy/sort.svg" alt="" />
        </div>
      </div>
      <div class="fr search" @click="toSearch">
        <van-icon name="search" />
        搜索
      </div>
    </div>
    <div v-if="data.length" class="list_box">
      <div
        @click="toDtl(item.id)"
        class="list"
        v-for="(item, index) in data"
        :key="index"
      >
        <div class="title">{{ item.name }}</div>
      </div>
    </div>
    <div v-else class="empty">
      <img src="../images/noData.png" alt="" />
      <div class="tips">
        <div>没有搜索结果</div>
        <div>请输入其他关键词试试</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        // 热度
        queryDesc: 2,
        // 时间
        queryOrderBy: 1,
        queryName: "",
        classificationIds: [],
        currentPage: 1,
        pageSize: 999
      },
      value: "",
      option: [],
      sortList: [
        {
          id: 1,
          name: "按热度",
          sort: 2
        },
        {
          id: 2,
          name: "按时间",
          sort: 3
        }
      ],
      isId: 1,
      // 全部分类ID
      ids: [],
      data: []
    };
  },
  methods: {
    // 获取类别
    getClassification() {
      this.$http.home.getClassification({}).then(res => {
        if (res.data) {
          let obj = res.data.map(item => {
            this.ids.push(item.id);
            this.form.classificationIds.push(item.id);
            return {
              text: item.classification,
              value: item.id
            };
          });
          this.option = [{ value: "", text: "全部政策" }, ...obj];
          this.getPolicyList();
        }
      });
    },
    // 获取政策列表
    getPolicyList() {
      this.$http.home.getPolicyList(this.form).then(res => {
        if (res.data) {
          this.data = res.data.pageInfo.content;
        }
      });
    },
    // 查看详情
    toDtl(id) {
      this.$router.push(`/policyDetail/${id}`);
    },
    changeClass(value) {
      this.form.classificationIds = [];
      if (value == "") {
        this.form.classificationIds = [...this.ids];
      } else {
        this.form.classificationIds.push(value);
      }
      this.getPolicyList();
    },
    querySelect(index) {
      this.isId = this.sortList[index].id;
      if (index == 0) {
        this.$set(this.sortList[1], "sort", 3);
        if (this.sortList[index].sort == 1) {
          this.$set(this.sortList[index], "sort", 2);
          this.form.queryDesc = 2;
        } else {
          this.$set(this.sortList[index], "sort", 1);
          this.form.queryDesc = 1;
        }
      } else {
        this.$set(this.sortList[0], "sort", 3);
        if (this.sortList[index].sort == 1) {
          this.$set(this.sortList[index], "sort", 2);
          this.form.queryOrderBy = 2;
        } else {
          this.$set(this.sortList[index], "sort", 1);
          this.form.queryOrderBy = 1;
        }
      }
      this.getPolicyList();
    },
    toSearch() {
      this.$router.push("/search");
    }
  },
  created() {
    this.getClassification();
  }
};
</script>
<style lang="less" scoped>
.policyList {
  position: fixed;
  top: 20px;
  left: 0;
  right: 0;
  .active {
    color: #6d90e2 !important;
  }
  padding: 0 15px 15px 7px;
  /deep/.van-dropdown-menu__bar {
    height: auto;
    box-shadow: none;
    font-size: 16px;
    font-weight: 600;
    color: #515359;
    line-height: 22px;
  }
  .type_title {
    font-size: 14px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.7);
    line-height: 20px;
  }
  .sotr_pic {
    margin-top: 3px;
  }
  .search {
    height: 25px;
    line-height: 25px;
    // background: #ffffff;
    box-shadow: 0px -1px 0px 0px #f7f9fa;
    border-radius: 14px;
    border: 1px solid #e1e4eb;
    color: #d2d5d9;
    font-size: 14px;
    padding: 0 10px;
    box-sizing: border-box;
  }
}
.list_box {
  padding: 0px 15px 15px 15px;
  .list {
    font-size: 14px;
    font-weight: 400;
    color: #515359;
    line-height: 22px;
    .title {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; //行数
      -webkit-box-orient: vertical;
      padding: 10px 0;
      border-bottom: 1px solid #AEACA7;
      color: #000;
    }
  }
}
.empty {
  width: 100%;
  text-align: center;
  img {
    margin-top: 85px;
    width: 117px;
    height: 110px;
  }
  .tips div:nth-child(1) {
    font-size: 16px;
    font-weight: 600;
    color: #515359;
    line-height: 22px;
    margin-top: 20px;
    margin-bottom: 4px;
  }
  .tips div:nth-child(2) {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.5);
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/policyList.vue